<template>
	<div class="set-secondary-password-view">
		<div class="decoration decoration-1"></div>
		<div class="decoration decoration-2"></div>
		<div class="decoration decoration-3"></div>
		<div class="content">
			<el-form class="form" :model="formData" status-icon :rules="rules" ref="formData" @keyup.enter.native="handleSubmit()">
				<div class="title">设置二级密码</div>
				<div class="subtitle">当异地登录或换设备登录时，将进行二级密码校验，以保障您的账号安全</div>
				
				<el-form-item prop="secondaryPassword">
					<el-input type="text" v-model="formData.secondaryPassword" maxlength="20" placeholder="请输入 6-20 位数字、字母或符号"
						prefix-icon="el-icon-lock"></el-input>
				</el-form-item>
							
				<el-form-item prop="confirmPassword">
					<el-input type="text" v-model="formData.confirmPassword" maxlength="20" placeholder="请再次输入二级密码"
						prefix-icon="el-icon-lock"></el-input>
				</el-form-item>
				
				<el-button class="submit-btn" type="primary" @click="handleSubmit()">立即设置</el-button>
			</el-form>
		</div>
	</div>
</template>

<script>
import { getDeviceId, getDeviceModel } from '../utils/deviceUtils'
import { initYunxinAfterLogin } from '../api/loginHelper.js'

export default {
	name: "SetSecondaryPassword",
	data() {
		var validateSecondaryPassword = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入二级密码'));
			}
			if (!/^[a-zA-Z0-9~!@#$%^&*()_+\-=\{\}\[\]:;"'<>,.?/\\\\]{6,20}$/.test(value)) {
				return callback(new Error('二级密码必须是 6-20 位数字、字母或符号'));
			}
			callback();
		};
		
		var validateConfirmPassword = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请确认二级密码'));
			}
			if (value !== this.formData.secondaryPassword) {
				return callback(new Error('两次输入的密码不一致'));
			}
			callback();
		};
		
		return {
			formData: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				secondaryPassword: '',
				confirmPassword: '',
				tempToken: '',
				deviceId: '',
				deviceModel: ''
			},
			rules: {
				secondaryPassword: [
					{ validator: validateSecondaryPassword, trigger: 'blur' }
				],
				confirmPassword: [
					{ validator: validateConfirmPassword, trigger: 'blur' }
				]
			}
		};
	},
	methods: {
		handleSubmit() {
			this.$refs.formData.validate((valid) => {
				if (valid) {
					// 获取设备信息
					const deviceId = getDeviceId();
					const deviceModel = getDeviceModel();
					
					// 构建提交数据
					const submitData = {
						terminal: this.formData.terminal,
						secondaryPassword: this.formData.secondaryPassword,
						tempToken: this.formData.tempToken,
						deviceId: deviceId,
						deviceModel: deviceModel
					};
					
					console.log('设置二级密码数据:', submitData);
					
					this.$http({
						url: "/user/setSecondaryPassword",
						method: 'POST',
						data: submitData
					}).then(async (loginInfo) => {
						this.$message.success("设置成功");
						setTimeout(() => {
							initYunxinAfterLogin(loginInfo).finally(() => {
							// 跳转到聊天页面
							this.$router.push("/home/chat");
							})
						}, 1500);
					}).catch((error) => {
						console.log("设置二级密码失败：", error);
					});
				}
			});
		}
	},
	mounted() {
		// 从 URL 参数中获取 tempToken
		const query = this.$route.query;
		if (query.tempToken) {
			this.formData.tempToken = query.tempToken;
			console.log('获取到 tempToken:', this.formData.tempToken);
		}
		
		// 获取设备信息
		this.formData.deviceId = getDeviceId();
		this.formData.deviceModel = getDeviceModel();
	}
}
</script>

<style scoped lang="scss">
.set-secondary-password-view {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	background: linear-gradient(135deg,
			#87adeb 0%,
			#8287ec 25%,
			#87adeb 50%,
			#898ee3 75%,
			#87adeb 100%);

	/* 装饰性元素 */
	.decoration {
		position: absolute;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
	}

	.decoration-1 {
		width: 450px;
		height: 450px;
		background: linear-gradient(45deg, rgba(255, 255, 255, 0.3) 0%, rgba(200, 220, 240, 0.4) 100%);
		top: -250px;
		right: -100px;
		animation: float 16s infinite ease-in-out;
	}

	.decoration-2 {
		width: 400px;
		height: 400px;
		background: linear-gradient(135deg, rgba(200, 220, 240, 0.4) 0%, rgba(255, 255, 255, 0.3) 100%);
		bottom: -200px;
		left: -100px;
		animation: float 12s infinite ease-in-out;
	}

	.decoration-3 {
		width: 300px;
		height: 300px;
		background: linear-gradient(45deg, rgba(161, 196, 253, 0.3) 0%, rgba(194, 233, 251, 0.4) 100%);
		top: 50%;
		right: 50px;
		animation: float 8s infinite ease-in-out;
	}

	@keyframes float {
		0%, 100% {
			transform: translateY(0) translateX(0);
		}
		25% {
			transform: translateY(-60px) translateX(30px);
		}
		50% {
			transform: translateY(30px) translateX(-45px);
		}
		75% {
			transform: translateY(-30px) translateX(-30px);
		}
	}

	.content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;

		.form {
			width: 360px;
			height: 420px;
			padding: 25px;
			box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
			background: rgba(255, 255, 255, 0.95);
			backdrop-filter: blur(8px);
			border-radius: 3%;
			overflow: hidden;

			.title {
				line-height: 40px;
				margin-bottom: 10px;
				font-size: 24px;
				font-weight: 700;
				color: var(--im-color-primary);
				letter-spacing: 1px;
				text-align: center;
			}

			.subtitle {
				line-height: 24px;
				margin-bottom: 30px;
				font-size: 14px;
				font-weight: 500;
				color: #666;
				text-align: center;
				opacity: 0.8;
			}

			::v-deep .el-form-item {
				margin-bottom: 20px;

				.el-input__inner {
					height: 50px;
					border-radius: 25px;
					border: 2px solid transparent;
					background: rgba(255, 255, 255, 0.9);
					box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
					transition: all 0.3s ease;
					padding-left: 50px;
					font-size: var(--im-font-size-large);

					&:focus {
						border-color: var(--im-color-primary);
						box-shadow: 0 8px 32px rgba(62, 69, 215, 0.15);
						transform: translateY(-2px);
					}

					&::placeholder {
						color: var(--im-text-color-light);
						font-size: var(--im-font-size);
					}
				}

				.el-input__prefix {
					left: 15px;

					.el-input__icon {
						color: var(--im-color-primary);
						font-size: 18px;
					}
				}

				.el-input__suffix {
					display: none;
				}
			}

			.submit-btn {
				width: 100%;
				height: 46px;
				border-radius: 23px;
				border: none;
				background: linear-gradient(135deg, var(--im-color-primary), #5a61e8);
				color: white;
				font-size: var(--im-font-size-large);
				font-weight: 600;
				box-shadow: 0 8px 16px rgba(62, 69, 215, 0.3);
				transition: all 0.3s ease;
				letter-spacing: 5px;
				margin-top: 20px;

				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 12px 40px rgba(62, 69, 215, 0.4);
				}

				&:active {
					transform: translateY(1px);
					box-shadow: 0 4px 16px rgba(62, 69, 215, 0.4);
				}
			}
		}
	}
}
</style>
